import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { AttachmentsGridPreview } from "@/components/AttachmentsGridPreview/AttachmentsGridPreview";
import { Header } from "@/components/Header";
import { ISectionProps, Section } from "@/components/Section";
import { MEDIA_SIZE_SM } from "@/core/media";
import { IAttachment } from "@/data/attachments";
import { Flex } from "@/eworkitComponents";

export interface IWorkOrderAttachmentsSectionProps extends ISectionProps {
  attachments: IAttachment[];
}

export const WorkOrderAttachmentsSection: FC<IWorkOrderAttachmentsSectionProps> = memo(
  ({ attachments, ...sectionProps }) => {
    const { t } = useTranslation("session");
    const isSmallScreen = useMedia(MEDIA_SIZE_SM);

    return (
      <Section
        width={24}
        padding={["md", "lg"]}
        innerMargin="md"
        flex
        direction={isSmallScreen ? "column" : "row"}
        borderRadius={!isSmallScreen}
        shadow={isSmallScreen ? "none" : "default"}
        {...sectionProps}>
        <Flex width={12} innerMargin="sm" direction="column">
          <Header size="sm" color="black" weight="bold">
            {t("WORK_ORDERS.DETAILS.ATTACHMENTS_SECTION.EXTERNAL_ATTACHMENTS_HEADER")}
          </Header>
          <AttachmentsGridPreview attachments={attachments} />
        </Flex>
      </Section>
    );
  },
);
